import {useRef} from 'react';

import type {MutableRefObject} from 'react';

/**
 * This custom React Hook maintains an updated ref of the provided input value.
 * It creates a ref with the initial input value and then immediately updates
 * the current value of the ref to the incoming value.
 *
 * @see https://trailhead.corp.stripe.com/docs/sail-ui/api/react/useUpdatedRef
 */
export default function useUpdatedRef<T>(value: T): MutableRefObject<T> {
  const ref = useRef<T>(value);

  // eslint-disable-next-line react-hooks/refs
  ref.current = value;

  return ref;
}
